export default {
    book_now: 'Rezervuoti dabar',
    minimum_age: 'Tik virš {age}',
    excess_liability: 'Draudimo polisas',
    security_deposit: 'Saugos depozitas',
    fuel_policy: 'Kuro politika',
    like_for_like: '„Patinka už patinka“',
    full_to_full: 'Pilnas bakas',
    miles_per_rental: '{mileage} nemokamos mylios nuomos metu',
    km_per_rental: '{mileage} nemokamos km nuomos metu',
    unlimited_mileage: 'Neribota rida',
    unlimited_mileage_km: 'Neribotas km',
    non_amendable: 'Nepataisoma',
    non_refundable: 'Negrąžinama',
    free_cancellation_until: 'Nemokamas atšaukimas iki',
    cancellation_in_line_with: 'Atšaukimas pagal',
    tcs: 'Terminai ir sąlygos',
    free_extras_on_collection: 'Du nemokami priedai paėmimo metu',
    glass_and_tyres_covered: 'Stiklas ir padangos įtrauktos',
    number_of_passengers: 'Keleivių skaičius',
    number_of_bags: 'Krepšių skaičius',
    fuel_type: 'Kuro rūšis',
    co2: 'CO2',
    aircon: 'Oro kondicionierius',
    transmission: 'Perdavimas',
    book_type: 'Rezervuoti {type}',
    debit_card_deposit: 'Debeto kortelė priimama už indėlius',
}



// WEBPACK FOOTER //
// ./node_modules/greenmotion-shared/lang/lt/quotes/price_card.js